import { QueryClient, useQuery } from '@tanstack/react-query';
import { getProjectDetailedReports } from '@/api/generated/projects/projects';
import { QUERY_KEY_DETAILED_REPORTS } from '@/constants/query-keys';

export function getDetailedReportsQueryKey(projectId: string | undefined) {
  return [QUERY_KEY_DETAILED_REPORTS, projectId] as const;
}

export function invalidateDetailedReports(queryClient: QueryClient) {
  return queryClient.invalidateQueries({ queryKey: [QUERY_KEY_DETAILED_REPORTS] });
}

export function useFetchDetailedReports(projectId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: getDetailedReportsQueryKey(projectId),
    queryFn: ({ signal }) => getProjectDetailedReports(projectId!, { signal }),
    enabled: !!projectId && enabled,
    keepPreviousData: true,
  });
}
